var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystoreLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7195 4.80227C9.0931 3.89262 6.48273 2.43193 2.43385 0.164866C2.16087 -0.0154129 1.8468 -0.0390381 1.57544 0.0528104L8.52218 6.99955L10.7195 4.80227Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.57551 0.0529785C1.52465 0.0702052 1.47516 0.0909867 1.42782 0.116088C1.12816 0.278184 0.907959 0.590097 0.907959 0.984589V13.0149C0.907959 13.4094 1.12813 13.7213 1.42782 13.8833C1.47507 13.9084 1.52454 13.9293 1.57534 13.9466L8.52225 6.99972L1.57551 0.0529785Z",
    fill: "#323781"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52235 6.99963L1.57544 13.9465C1.84688 14.039 2.16096 14.0172 2.43401 13.8343C6.36056 11.6356 8.9415 10.1922 10.5867 9.27482C10.6325 9.24909 10.6774 9.22393 10.7217 9.19902L8.52235 6.99963Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.907959 6.99951V13.0146C0.907959 13.4091 1.12813 13.7211 1.42782 13.8831C1.47507 13.9082 1.52454 13.9291 1.57534 13.9464L8.52225 6.99951H0.907959Z",
    fill: "#323781"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.43383 0.164827C2.10967 -0.0492217 1.7274 -0.043124 1.42773 0.115909L8.41673 7.10493L10.7194 4.80223C9.09308 3.89258 6.48271 2.43189 2.43383 0.164827Z",
    fill: "#5F67EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41678 6.89404L1.42773 13.883C1.72742 14.042 2.10967 14.0512 2.43383 13.8341C6.36037 11.6354 8.94132 10.192 10.5865 9.27461C10.6323 9.24888 10.6772 9.22372 10.7215 9.19881L8.41678 6.89404Z",
    fill: "#5F67EC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6203 6.99948C13.6203 6.66615 13.4521 6.32977 13.1187 6.14323C13.1187 6.14323 12.4953 5.79539 10.5844 4.72656L8.31152 6.99948L10.5867 9.27464C12.4766 8.2135 13.1187 7.8557 13.1187 7.8557C13.4521 7.66919 13.6203 7.3328 13.6203 6.99948Z",
    fill: "#8D93F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1187 7.85576C13.4521 7.66922 13.6203 7.33284 13.6203 6.99951H8.31152L10.5867 9.27467C12.4766 8.21356 13.1187 7.85576 13.1187 7.85576Z",
    fill: "#8D93F2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreLogo);
export default __webpack_public_path__ + "static/media/playstore_logo.a2f1229cc4db713d217683720c5f1672.svg";
export { ForwardRef as ReactComponent };